import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarkChatUnreadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mark_chat_unread"}/>
}
